import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

export const Wrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 456px;
`;

export const Title = styled(Typography)(({ theme }) => ({
    display: "block",
    textAlign: "center",
    color: theme.kaltura.palette.tone1,
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
    display: "block",
    textAlign: "center",
    color: theme.kaltura.palette.tone2,
}));

export const StyledNoResults = styled.div`
    text-align: center;
`;
